{
    "statusType": {
        "DEACTIVE": "Sin activar",
        "NOT_REGISTER": "En espera",
        "REGISTER": "Activo",
        "EXPIRED": "Caducado",
        "RETURNED": "Devuelto"
    }
}
